import React from 'react';
import { IconButton, Tooltip } from '@ds';

import { DSDeleteIcon, DSCopyIcon } from '@ds-icons';

import { NodeViewProps } from '@tiptap/core';

interface MenuItemProps {
  content: string;
  onClick: () => void;
  disabled: boolean;
  contentIcon: React.ReactNode;
}

const MenuItem = ({
  content,
  onClick,
  disabled,
  contentIcon
}: MenuItemProps) => (
  <Tooltip content={content} placement="bottom" arrow={false}>
    <IconButton
      type="secondary"
      onClick={onClick}
      disabled={disabled}
      Icon={contentIcon}
    />
  </Tooltip>
);

const BlockItemMenu = ({ editor, getPos, node }: NodeViewProps) => {
  const runAndFocus = (trCallback: (tr: typeof editor.state.tr) => void) => {
    const { tr } = editor.state;
    trCallback(tr);
    editor.view.dispatch(tr);
    editor.view.focus();
  };

  const handleDuplicate = () => {
    runAndFocus(tr => {
      const duplicate = node.type.create(node.attrs, node.content, node.marks);
      const insertPos = getPos() + node.nodeSize;
      tr.insert(insertPos, duplicate);
    });
  };

  const handleRemove = () => {
    runAndFocus(tr => {
      const pos = getPos();
      tr.delete(pos, pos + node.nodeSize);
    });
  };

  return (
    <div className="block-item-menu" role="menu" aria-label="Block item menu">
      <MenuItem
        content="Duplicate"
        onClick={handleDuplicate}
        disabled={false}
        contentIcon={<DSCopyIcon />}
      />
      <MenuItem
        content="Delete"
        onClick={handleRemove}
        disabled={false}
        contentIcon={<DSDeleteIcon />}
      />
    </div>
  );
};

export default BlockItemMenu;
